import { useState } from 'react';

export function useSearch(initialSearch = '') {
  const [search, setSearch] = useState<string>(initialSearch);

  const clearSearch = () => setSearch('');

  return [search, setSearch, clearSearch] as const;
}
